import {
  SUBMIT_SEARCH_REINDEX,
  SubmitSearchReindexAction,
} from "./SearchReindexTypes";

export const submitSearchReindex = (): SubmitSearchReindexAction => {
  return {
    type: SUBMIT_SEARCH_REINDEX.REQUEST,
  };
};
